// @ts-nocheck
export default "> * *";
